/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedDetailFramingOptions_item = {
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_item">;
    readonly " $refType": "PdpSharedDetailFramingOptions_item";
};
export type PdpSharedDetailFramingOptions_item$data = PdpSharedDetailFramingOptions_item;
export type PdpSharedDetailFramingOptions_item$key = {
    readonly " $data"?: PdpSharedDetailFramingOptions_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailFramingOptions_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailFramingOptions_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '49d0f6230269b3ea24a96b9d382155b5';
export default node;
